import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import './utils/permission'
import './utils/passiveEvents'

Vue.use(ElementUI)

Vue.config.productionTip = false

// 创建Vue实例前检查token状态
// 如果存在有效的access_token，则启动token过期检查定时器
if (store.state.auth.access_token) {
  store.dispatch('auth/startTokenExpiryCheck')
}

// 保存当前路由到localStorage
router.afterEach((to) => {
  if (to.path && to.path !== '/login' && to.path !== '/home') {
    localStorage.setItem('last_visited_route', to.fullPath)
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  async mounted() {
    // 尝试从localStorage恢复之前的路由
    const lastVisitedRoute = localStorage.getItem('last_visited_route')
    
    // 只要已经登录并且存在上次访问的路由，就尝试恢复
    if (lastVisitedRoute && this.$store.state.auth.access_token) {
      try {
        // 确保权限已经加载完成
        if (!this.$store.state.permission.isLoaded) {
          await this.$store.dispatch('permission/generateRoutes')
        }
        
        // 延迟导航以确保路由已经正确加载
        setTimeout(() => {
          this.$router.push(lastVisitedRoute).catch(err => {
            // 处理可能的导航错误，例如路由不存在
            console.error('恢复路由失败:', err)
          })
        }, 100)
      } catch (error) {
        console.error('恢复路由失败:', error)
      }
    }
  }
}).$mount('#app')
